module.exports = __webpack_public_path__ + "img/classlist.44882f61.svg";